import { CheckCircle2, CalendarClock, Sparkles, AlertCircle, HelpCircle } from "lucide-react";

export const STATUS = {
  confirmed: { label: "Confirmed", cls: "bg-emerald-50 text-emerald-800 border-emerald-200", Icon: CheckCircle2 },
  planned: { label: "Planned", cls: "bg-stone-100 text-stone-700 border-stone-200", Icon: CalendarClock },
  idea: { label: "Idea", cls: "bg-amber-50 text-amber-800 border-amber-200", Icon: Sparkles },
  action_required: { label: "Action required", cls: "bg-rose-50 text-rose-800 border-rose-300", Icon: AlertCircle },
  tbc: { label: "TBC", cls: "bg-indigo-50 text-indigo-800 border-indigo-200", Icon: HelpCircle },
};

export function StatusBadge({ status = "planned", className = "", testId }) {
  const s = STATUS[status] || STATUS.planned;
  return (
    <span data-testid={testId || `status-badge-${status}`} className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold tracking-wide ${s.cls} ${className}`}>
      <s.Icon className="h-3 w-3" /> {s.label}
    </span>
  );
}
